export default __webpack_public_path__ + "static/media/Logo.c83a0607.webp";